<hr style="margin-top: 0px; margin-bottom: 15px;">
<div class="container-fluid" *ngIf="eventsLoaded && dashboardsLoaded && awaitAssociatedUserGroups && userGroupsLoaded; else loading">

    <div class="dashboard-layout" *ngIf="!wizardMode">

        <!-- LEFT SIDEBAR (expanded) -->
        <div class="dashboard-left-col" [class.collapsed]="sidebarCollapsed">
            <div class="dashboard-left-header">
                <label class="dashboard-heading">DASHBOARDS</label>
                <i class="fas dashboard-collapse-toggle"
                    [ngClass]="sidebarCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'"
                    [title]="sidebarCollapsed ? 'Show dashboard list' : 'Hide dashboard list'"
                    (click)="toggleSidebar()"></i>
            </div>
            <div class="dashboard-loaded-name" *ngIf="selectedDashboard != undefined">{{selectedDashboard.name}}</div>
            <div class="dashboard-no-selection-spacer" *ngIf="selectedDashboard == undefined"></div>

            <div class="dashboard-left-buttons">
                <button type="button" class="btn btn-success" (click)="prepNewDashboard(template)">New</button>
                <button type="button" class="btn btn-success" (click)="enterCreateWizard()">Create with Wizard</button>
                <button type="button" class="btn btn-dark" (click)="dashboardSelectionChanged()"
                    [disabled]="selectedDashboard == undefined">Refresh</button>
            </div>

            <div class="dashboard-list-panel" *ngIf="!sidebarCollapsed">
                <div class="dashboard-list-panel-header">Dashboards ({{dashboardsToDisplay.length}})</div>
                <input type="text" class="form-control dashboard-search" name="dashboardSearch"
                    placeholder="Search" [(ngModel)]="dashboardSearch" (ngModelChange)="dashboardSearchTextChanged()">
                <i class="fa-solid fa-angle-up dashboard-scroll-arrow" title="Scroll up" (click)="scrollDashboardList(-1)"></i>
                <div #dashboardListScroll class="dashboard-list-scroll">
                    <div class="dashboard-row" *ngFor="let row of dashboardsDisplayed"
                        [class.selected]="selectedDashboard != undefined && selectedDashboard.id === row.id"
                        (click)="selectDashboardRow(row)">
                        <input type="radio" name="dashboardRadio"
                            [checked]="selectedDashboard != undefined && selectedDashboard.id === row.id">
                        <span class="dashboard-row-name" title="id={{row.id}}">{{row.name}}</span>
                        <i *ngIf="row.userFeatureAccess['EditDashboard']" class="fas fa-pencil-alt" title="Edit"
                            style="color: var(--kig-icon-edit); cursor: pointer;"
                            (click)="editDashboardRow(row, template); $event.stopPropagation()"></i>
                        <i *ngIf="!row.userFeatureAccess['EditDashboard'] && row.userFeatureAccess['ViewDashboard']"
                            class="fas fa-eye" title="View"
                            style="color: var(--kig-icon-edit); cursor: pointer;"
                            (click)="editDashboardRow(row, template); $event.stopPropagation()"></i>
                        <i *ngIf="row.userFeatureAccess['DeleteDashboard']" class="far fa-trash-alt" title="Delete"
                            style="color: var(--kig-icon-delete); cursor: pointer; margin-left: 12px;"
                            (click)="deleteDashboardRow(row); $event.stopPropagation()"></i>
                    </div>
                </div>
                <i class="fa-solid fa-angle-down dashboard-scroll-arrow" title="Scroll down" (click)="scrollDashboardList(1)"></i>
            </div>
        </div>

        <!-- RIGHT CONTENT -->
        <div class="dashboard-right-col">

            <div class="dashboard-badge-grid">
                <dashboard-alert-badge *ngIf="generalStatsEventsLeftOn.length > 0 || generalStatsEventsLeftOnWaiting"
                    title="Irrigation Events with moisture &lt; 5%"
                    [items]="generalStatsEventsLeftOn" [loading]="generalStatsEventsLeftOnWaiting"></dashboard-alert-badge>
                <dashboard-alert-badge *ngIf="generalStatsEventsWithNoLogs.length > 0"
                    title="Enabled events with no analysis log (last 30 minutes)"
                    [items]="generalStatsEventsWithNoLogs"></dashboard-alert-badge>
                <dashboard-alert-badge *ngIf="generalStatsRecentActionFails.length > 0"
                    title="Event actions in waiting or failed state that were triggered (last 30 minutes)"
                    [items]="generalStatsRecentActionFails"></dashboard-alert-badge>
                <dashboard-alert-badge *ngIf="generalStatsDeviceConnectivity.length > 0"
                    title="Low Gateway Connectivity (last 60 minutes)"
                    [items]="generalStatsDeviceConnectivity"></dashboard-alert-badge>
            </div>


    <br>
    <div *ngIf="selectedDashboard != undefined">
        <div *ngIf="dashboardFinishedTasks; else loading">
            <tabset *ngIf="dashboardEvents.length > 0 || dashboardCharts.length > 0 || selectedDashboardImageFavorites.length > 0 || selectedDashboardMapFavorites.length > 0">

                <tab heading="ISAL Automation" [active]="false" *ngIf="canUserViewIsal && selectedDashboard.includeIsalTab == 1">
                    <isal
                        [dashboardEvents]='dashboardEvents'
                        [associatedUserGroups]='associatedUserGroups'>
                    </isal>
                </tab>

                <tab heading="Favorites" [active]="true" *ngIf="showsFavoritesTab(selectedDashboard)">
                    <div style="margin: 10px; display: flex; gap: 12px; align-items: center; flex-wrap: wrap; margin-top: 10px; margin-bottom: 20px;">
                        <label style="margin-right: 10px;">Tile Size:</label>
                        <input type="radio" [(ngModel)]="favoritesLayoutSize" name="favoritesLayoutSize" value="Small"  (ngModelChange)="onFavoritesLayoutSizeChange()" /> <label style="margin-right: 10px;">Small</label>
                        <input type="radio" [(ngModel)]="favoritesLayoutSize" name="favoritesLayoutSize" value="Medium" (ngModelChange)="onFavoritesLayoutSizeChange()" /> <label style="margin-right: 10px;">Medium</label>
                        <input type="radio" [(ngModel)]="favoritesLayoutSize" name="favoritesLayoutSize" value="Large"  (ngModelChange)="onFavoritesLayoutSizeChange()" /> <label style="margin-right: 10px;">Large</label>
                        <small *ngIf="canReorderFavorites && favoriteTiles.length > 1" class="text-muted">Drag a tile by its title bar to reorder.</small>
                    </div>

                    <!-- Event, chart, image and map tiles intermixed; dragged by their title bars
                         (cdkDragHandle) and saved as the dashboard's favoritesOrder. -->
                    <div class="favorites-grid" cdkDropList cdkDropListOrientation="mixed"
                         [cdkDropListData]="favoriteTiles" (cdkDropListDropped)="onFavoriteTileDropped($event)">
                        <div *ngFor="let tile of favoriteTiles; trackBy: trackFavoriteTileByKey"
                             class="favorite-tile" cdkDrag [cdkDragDisabled]="!canReorderFavorites"
                             [class.reorderable]="canReorderFavorites" [ngSwitch]="tile.kind">

                            <!-- Event tile: the event's chart (if any) + conditions + recent actions. -->
                            <div *ngSwitchCase="'event'" [style.width]="tileWidth">
                                <div class="card bg-light mb-3" [style.max-width]="tileWidth">
                                    <div class="card-header" cdkDragHandle style="background-color: var(--kig-section-header-bg); display: flex; align-items: center; gap: 8px;">
                                        <h6 class="card-title" style="margin-bottom: 0rem; flex: 1;">
                                            {{tile.event.eventName}}
                                        </h6>
                                        <i *ngIf="tile.event.isChartAvailable && canEditChartFavorite(tile.event.chartFavoriteID)"
                                           class="fas fa-pencil-alt" title="Edit chart favorite"
                                           style="color: var(--kig-icon-edit); cursor: pointer;"
                                           (click)="editChartFavoriteRow(tile.event.chartFavoriteID); $event.stopPropagation()"></i>
                                    </div>
                                    <div class="card-body" style="padding: 0.3rem">
                                        <div *ngIf="tile.event.isChartAvailable" style="background-color: white;">
                                            <div (click)="showDashboardChart(dashboardChart, tile.event)" style="cursor: pointer;">
                                                <chart-readings-echart-modal
                                                    [minimal]="true"
                                                    [sensors]="tile.event.sensors"
                                                    [sensorReadings]="tile.event.sensorReadings"
                                                    [sensorReadingTypes]="tile.event.sensorReadingTypes"
                                                    [includeCalValues]="tile.event.includeCalValues ?? true"
                                                    [includeOrigValues]="tile.event.includeOrigValues ?? false"
                                                    [savedChartDetails]="tile.event.savedChartDetails"
                                                    [chartFavoriteId]="tile.event.chartFavoriteID || 0"
                                                    [manualScaling]="tile.event.manualScaling"
                                                    [manualScaleYMin]="tile.event.manualScaleYMin"
                                                    [manualScaleYMax]="tile.event.manualScaleYMax"
                                                    [chartHeight]="tileChartHeight">
                                                </chart-readings-echart-modal>
                                            </div>
                                        </div>
                                        <br>
                                        <div *ngIf="!tile.event.eventDisabled">
                                            <table width="100%" style="margin-bottom: 0px;">
                                                <tr>
                                                    <td width="80%" style="color: #1c4966;">
                                                        Conditions
                                                    </td>
                                                    <td width="20%" align="center" style="color: #1c4966;">
                                                        Values
                                                    </td>
                                                </tr>
                                            </table>

                                            <table width="100%" style="margin-bottom: 15px">
                                                <tr *ngFor = "let data of tile.event.eventConditions">
                                                    <td width="80%" style="font-size: 14px;">
                                                        {{data.condition}}
                                                    </td>
                                                    <td width="20%" style="font-size: 14px; text-align: center;">
                                                        <div (click)="showRecentConditionValues(tile.event, data, conditionValueHistoryTemplate)" style="cursor: pointer;" [ngStyle]="{'color': getEventLogColor(data.errorCode)}">
                                                            {{data.value | slice:0:10 }}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <div *ngIf="!tile.event.eventDisabled" style="text-align: center; color: #1c4966; cursor: pointer;">Recent Actions</div>
                                        <div *ngIf="!tile.event.eventDisabled && tile.event.eventLogHistory.length > 0" (click)="showEventLogHistory(triggerHistoryTemplate, tile.event.eventId)"
                                            class="text-center pointer" [ngStyle]="{'background-color': getEventLogColor(tile.event.eventLogHistory[0].Result)}">
                                            {{tile.event.lastTriggeredDate | date : 'medium'}}
                                            <br>
                                            <table style="width: 100%;">
                                                <tr style="font-size: 8px; line-height: 8px">
                                                    <td *ngFor="let actionResult of tile.event.lastTriggeredActionResults" [ngStyle]="{'background-color': getEventLogColor(actionResult)}">
                                                        &nbsp;
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Chart-only tile (a chart favorite not tied to an event). -->
                            <div *ngSwitchCase="'chart'" [style.width]="tileWidth">
                                <div class="card bg-light mb-3" [style.max-width]="tileWidth">
                                    <div class="card-header" cdkDragHandle style="background-color: var(--kig-section-header-bg); display: flex; align-items: center; gap: 8px;">
                                        <h6 class="card-title" style="margin-bottom: 0rem; flex: 1;">
                                            {{tile.chart.name}}
                                        </h6>
                                        <i *ngIf="canEditChartFavorite(tile.chart.chartFavoriteID)"
                                           class="fas fa-pencil-alt" title="Edit chart favorite"
                                           style="color: var(--kig-icon-edit); cursor: pointer;"
                                           (click)="editChartFavoriteRow(tile.chart.chartFavoriteID); $event.stopPropagation()"></i>
                                    </div>
                                    <div style="background-color: white; padding: 0.3rem" class="card-body">
                                        <div (click)="showDashboardChartWithNoEvent(dashboardChart, tile.chart)" style="cursor: pointer;">
                                            <chart-readings-echart-modal
                                                [minimal]="true"
                                                [sensors]="tile.chart.sensors"
                                                [sensorReadings]="tile.chart.sensorReadings"
                                                [sensorReadingTypes]="tile.chart.sensorReadingTypes"
                                                [includeCalValues]="tile.chart.includeCalValues ?? true"
                                                [includeOrigValues]="tile.chart.includeOrigValues ?? false"
                                                [savedChartDetails]="tile.chart.savedChartDetails"
                                                [chartFavoriteId]="tile.chart.chartFavoriteID || 0"
                                                [manualScaling]="tile.chart.manualScaling"
                                                [manualScaleYMin]="tile.chart.manualScaleYMin"
                                                [manualScaleYMax]="tile.chart.manualScaleYMax"
                                                [chartHeight]="tileChartHeight">
                                            </chart-readings-echart-modal>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Image tile: kig-image-favorite's header is its drag handle. -->
                            <div *ngSwitchCase="'image'" class="card bg-light mb-3" style="max-width: 100%; cursor: pointer;" title="Click to enlarge"
                                 (click)="showDashboardImageFavorite(dashboardImageFavorite, tile.image)">
                                <kig-image-favorite [imageFavorite]="tile.image"
                                                    [size]="favoritesLayoutSize"
                                                    [labelsEditable]="false"
                                                    [username]="username"
                                                    [showEditButton]="canEditImageFavorite(tile.image)"
                                                    [dragHandle]="canReorderFavorites"
                                                    (editRequested)="editImageFavoriteRow(tile.image.id)">
                                </kig-image-favorite>
                            </div>

                            <!-- Map tile: the card header is the drag handle (the map body must stay free for panning). -->
                            <div *ngSwitchCase="'map'" [style.width]="tileWidth">
                                <div class="card bg-light mb-3" [style.max-width]="tileWidth">
                                    <div class="card-header" cdkDragHandle style="background-color: var(--kig-section-header-bg); display: flex; align-items: center; gap: 8px;">
                                        <h6 class="card-title" style="margin-bottom: 0rem; flex: 1;" [title]="tile.map.description ?? ''">
                                            {{tile.map.name}}
                                        </h6>
                                        <i class="fas fa-expand-alt" title="Enlarge"
                                           style="color: var(--kig-icon-edit); cursor: pointer;"
                                           (click)="showDashboardMapFavorite(dashboardMapFavorite, tile.map); $event.stopPropagation()"></i>
                                        <i *ngIf="canEditMapFavorite(tile.map)"
                                           class="fas fa-pencil-alt" title="Edit map favorite"
                                           style="color: var(--kig-icon-edit); cursor: pointer;"
                                           (click)="editMapFavoriteRow(tile.map.id); $event.stopPropagation()"></i>
                                    </div>
                                    <div style="background-color: white; padding: 0.3rem" class="card-body">
                                        <kig-map-favorite-tile [mapFavorite]="tile.map" [height]="tileChartHeight"></kig-map-favorite-tile>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <small *ngIf="favoriteTiles.length === 0" class="text-muted">
                            No favorites on this dashboard. Add a chart, image or map favorite with the Create wizard or the dashboard's edit dialog.
                        </small>
                    </div>
                </tab>

                <tab heading="Notifiations (Events & Actions)" [active]="false" *ngIf="selectedDashboard.includeEventsTab == 1">
                    <p-table #eventsTable [columns]="eventCols" [value]="dashboardEvents" sortField="EventName" >

                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th *ngFor="let col of columns" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none">
                                    {{col.header}}
                                    <p-sortIcon *ngIf="col.header != 'Window' && col.header != 'Current Event Conditions'" [field]="col.field"></p-sortIcon>
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr *ngIf="!rowData.eventDisabled">
                                <td width="20%" style="flex: none;">
                                    {{rowData.eventName}}
                                </td>
                                <td width="10%" class="text-left" style="flex: none;">
                                    <div *ngIf="rowData.eventActiveState=='disabled'" class="far fa-clock" style="color: black; font-size: 16px;" pTooltip="Event Disabled" tooltipPosition="top"></div>
                                    <div *ngIf="rowData.eventActiveState=='active'" class="far fa-clock" style="color: #64a70b; font-size: 16px;" pTooltip="Event Window Active" tooltipPosition="top"></div>
                                    <div *ngIf="rowData.eventActiveState=='inactive'" class="far fa-clock" style="color: #c8102e; font-size: 16px;" pTooltip="Event Window Inactive" tooltipPosition="top"></div>
                                </td>
                                <td width="38%" style="flex: none;">
                                    <table style="width: 100%;">
                                        <tr *ngFor = "let data of rowData.eventConditions">
                                            <td width="30%" *ngIf="rowData.eventType=='Sensor Based'" style="flex: none;">
                                                {{data.sensorGroupName}}
                                            </td>
                                            <td width="37%" *ngIf="rowData.eventType=='Sensor Based'" style="flex: none;">
                                                {{data.condition}}
                                            </td>
                                            <td width="80%" *ngIf="rowData.eventType=='Timer Based'" style="flex: none;">
                                                {{data.condition}}
                                            </td>
                                            <td width="18%">
                                                <div (click)="showRecentConditionValues(rowData, data, conditionValueHistoryTemplate)" style="cursor: pointer; flex: none; color: dodgerblue;" [ngStyle]="{'color': getEventLogColor(data.errorCode)}" >
                                                    {{data.value | slice:0:10 }}
                                                </div>
                                            </td>
                                            <td width="15%" *ngIf="rowData.eventType=='Sensor Based'" style="flex: none;">
                                                Age: {{data.plantAge}}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td width="20%" style="flex: none;">
                                    <div *ngIf="rowData.eventLogHistory.length > 0"
                                        (click)="showEventLogHistory(triggerHistoryTemplate, rowData.eventId)"
                                        class="text-center pointer"
                                        [ngStyle]="{'background-color': getEventLogColor(rowData.eventLogHistory[0].result)}">
                                        {{rowData.lastTriggeredDate | date : 'medium'}}
                                        <br>
                                        <table style="width: 100%;">
                                            <tr style="font-size: 6px; line-height: 6px">
                                                <td *ngFor="let actionResult of rowData.lastTriggeredActionResults" [ngStyle]="{'background-color': getEventLogColor(actionResult)}">
                                                    &nbsp;
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </td>
                                <td width="15%" style="flex: none;">
                                    <div class="text-center">
                                        {{rowData.elapsedTime}}
                                    </div>
                                </td>

                            </tr>
                        </ng-template>

                        <ng-template pTemplate="emptymessage" let-columns>
                            <tr>
                                <td [attr.colspan]="columns.length">
                                    No records found
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="caption" let-rowData>
                            <div style="text-align: left;">
                                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                                <input type="text" pInputText size="30" placeholder="Search Event Names"
                                    (input)="eventsTable.filterGlobal($event.target.value, 'contains')"
                                    style="width:auto; height: 30px;">
                            </div>
                        </ng-template>

                    </p-table>
                </tab>

            </tabset>
        </div>
    </div>
        </div> <!-- /.dashboard-right-col -->
    </div> <!-- /.dashboard-layout -->

    <!-- Inline create wizard: replaces the left list + right tabs while active -->
    <dashboard-create-wizard *ngIf="wizardMode"
        [dashboards]="dashboardsToDisplay"
        [associatedUserGroups]="associatedUserGroups"
        [username]="username"
        [editFavorite]="favoriteBeingEdited"
        [editImageFavorite]="imageFavoriteBeingEdited"
        [editMapFavorite]="mapFavoriteBeingEdited"
        [gateways]="imageFavoriteGateways"
        (cancelled)="onWizardCancelled()"
        (created)="onWizardCreated($event)"
        (favoriteUpdated)="onFavoriteUpdated()"
        (imageFavoriteUpdated)="onImageFavoriteUpdated()"
        (mapFavoriteUpdated)="onMapFavoriteUpdated()">
    </dashboard-create-wizard>

    <p-confirmDialog #cd>
        <ng-template #footer>
            <button type="button" class="btn btn-success" (click)="cd.onAccept()">Yes</button>
            <button type="button" class="btn btn-basic" (click)="cd.onReject()">No</button>
        </ng-template>
    </p-confirmDialog>
</div>


<ng-template #template>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="editDashboard-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">{{titleForDashboardModal}}</h5>
            <button
                (click)="modalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
        <div class="modal-body">
            <div class="container-fluid">
                <div class="col-md-12">
                    <div class="form-group" style="margin-bottom: 20px;">
                        <label for="dashboardName">Name*</label>
                        <input type="text" id="dashboardName" name="dashboardName" class="form-control"
                            [(ngModel)]="dashboardName" required />
                    </div>

                    <div class="form-group" style="margin-bottom: 25px;">
                        <label for="UserGroup">Access Group*</label>
                        <ngx-select-dropdown name="userGroupSelection" [config]="userGroupconfig"
                            [options]="associatedUserGroups" [(ngModel)]="selectedUserGroup"></ngx-select-dropdown>
                    </div>

                    <div style="display: flex; align-items: center; gap: 10px;">
                        <input type="checkbox" id="includeFavoritesTab" name="includeFavoritesTab" [(ngModel)]="includeFavoritesTab" />
                        <label for="includeFavoritesTab">Show Favorites Tab</label>
                    </div>

                    <div style="display: flex; align-items: center; gap: 10px;">
                        <input type="checkbox" id="includeEventsTab" name="includeEventsTab" [(ngModel)]="includeEventsTab" />
                        <label for="includeEventsTab">Show Events & Actions Tab</label>
                    </div>

                    <div *ngIf="canUserViewIsal" style="display: flex; align-items: center; gap: 10px;">
                        <input type="checkbox" id="includeIsalTab" name="includeIsalTab" [(ngModel)]="includeIsalTab" />
                        <label for="includeIsalTab">Show ISAL Tab</label>
                    </div>

                    <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 20px;">
                        <!-- <input type="checkbox" id="computeActionSumCountsForEvents" name="computeActionSumCountsForEvents" [(ngModel)]="computeActionSumCountsForEvents" />
                        <label for="computeActionSumCountsForEvents">Compute Action Sum Counts for Events</label> -->
                    </div>

                    <tabset>
                        <tab heading="Events and Actions" active="true">
                            <div class="form-group">
                                <!-- <p-table #EventsTable [columns]="triggerListCols" [value]="eventSelection" [scrollable]="true" scrollHeight="20em"> -->
                                <p-table #EventsTable [columns]="triggerListCols" [value]="eventsDisplayed" [scrollable]="true" scrollHeight="20em">
                                    <ng-template pTemplate="caption">
                                        <div style="text-align: left; display: flex; gap: 1em; align-items: center;">
                                            <form (ngSubmit)="searchEventsTextChanged()">
                                                <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchEventsTextChanged()"></i>
                                                <input [(ngModel)]="eventsSearch" placeholder="Search" size="25" style="width: 190px; height: 35px" type="text" name="eventsSearch" autocomplete="off"/>
                                                <label style="margin-left: 10px;">{{ eventsSearchNote }}</label>
                                            </form>
                                        </div>
                                    </ng-template>

                                    <ng-template pTemplate="header" let-columns>
                                        <tr style="height: 45px;">
                                            <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                                                [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
                                        <tr style="height: 40px;">
                                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                                <p-checkbox id="{{rowData.name}}" name="{{rowData.name}}"
                                                    [(ngModel)]="rowData.checked" binary="true"></p-checkbox>
                                            </td>
                                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                                <div style="display: flex; align-items: center; justify-content: space-between;">
                                                    <span>{{rowData.name}}</span>
                                                    <i class="fas fa-pencil-alt" title="Edit notification"
                                                        style="color: var(--kig-icon-edit); cursor: pointer;"
                                                        (click)="editEventRow(rowData.id); $event.stopPropagation()"></i>
                                                </div>
                                            </td>

                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </tab>
                        <tab heading="Chart Favorites">
                            <div class="form-group">
                                <!-- <p-table #ChartFavorites [columns]="chartListCols" [value]="chartSelection" [scrollable]="true" scrollHeight="20em"> -->
                                <p-table #ChartFavorites [columns]="chartListCols" [value]="chartsDisplayed" [scrollable]="true" scrollHeight="20em">
                                    <ng-template pTemplate="caption">
                                        <div style="text-align: left; display: flex; gap: 1em; align-items: center;">
                                            <form (ngSubmit)="searchChartsTextChanged()">
                                                <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchChartsTextChanged()"></i>
                                                <input [(ngModel)]="chartsSearch" placeholder="Search" size="25" style="width: 190px; height: 35px" type="text" name="chartsSearch" autocomplete="off"/>
                                                <label style="margin-left: 10px;">{{ chartsSearchNote }}</label>
                                            </form>
                                        </div>
                                    </ng-template>

                                    <ng-template pTemplate="header" let-columns>
                                        <tr style="height: 45px;">
                                            <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                                                [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
                                        <tr style="height: 40px;">
                                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                                <p-checkbox id="{{rowData.id}}" name="{{rowData.id}}"
                                                    [(ngModel)]="rowData.checked" binary="true"></p-checkbox>
                                            </td>
                                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                                {{rowData.name}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </tab>
                        <tab heading="Image Favorites">
                            <div class="form-group">
                                <p-table #ImageFavorites [columns]="chartListCols" [value]="imagesDisplayed" [scrollable]="true" scrollHeight="20em">
                                    <ng-template pTemplate="caption">
                                        <div style="text-align: left; display: flex; gap: 1em; align-items: center;">
                                            <form (ngSubmit)="searchImagesTextChanged()">
                                                <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchImagesTextChanged()"></i>
                                                <input [(ngModel)]="imagesSearch" placeholder="Search" size="25" style="width: 190px; height: 35px" type="text" name="imagesSearch" autocomplete="off"/>
                                                <label style="margin-left: 10px;">{{ imagesSearchNote }}</label>
                                            </form>
                                        </div>
                                    </ng-template>

                                    <ng-template pTemplate="header" let-columns>
                                        <tr style="height: 45px;">
                                            <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                                                [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
                                        <tr style="height: 40px;">
                                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                                <p-checkbox id="image{{rowData.id}}" name="image{{rowData.id}}"
                                                    [(ngModel)]="rowData.checked" binary="true"
                                                    (ngModelChange)="onImageFavoriteChecked($event)"></p-checkbox>
                                            </td>
                                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                                {{rowData.name}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </tab>
                        <tab heading="Map Favorites">
                            <div class="form-group">
                                <p-table #MapFavorites [columns]="chartListCols" [value]="mapsDisplayed" [scrollable]="true" scrollHeight="20em">
                                    <ng-template pTemplate="caption">
                                        <div style="text-align: left; display: flex; gap: 1em; align-items: center;">
                                            <form (ngSubmit)="searchMapsTextChanged()">
                                                <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchMapsTextChanged()"></i>
                                                <input [(ngModel)]="mapsSearch" placeholder="Search" size="25" style="width: 190px; height: 35px" type="text" name="mapsSearch" autocomplete="off"/>
                                                <label style="margin-left: 10px;">{{ mapsSearchNote }}</label>
                                            </form>
                                        </div>
                                    </ng-template>

                                    <ng-template pTemplate="header" let-columns>
                                        <tr style="height: 45px;">
                                            <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                                                [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
                                        <tr style="height: 40px;">
                                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                                <p-checkbox id="map{{rowData.id}}" name="map{{rowData.id}}"
                                                    [(ngModel)]="rowData.checked" binary="true"
                                                    (ngModelChange)="onMapFavoriteChecked($event)"></p-checkbox>
                                            </td>
                                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                                {{rowData.name}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </tab>
                    </tabset>

                    <div *ngIf="titleForDashboardModal != 'New Dashboard' && editingDashboard?.userFeatureAccess?.['EditDashboard']" style="margin-top: 15px;">
                        <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
                        <button type="button" class="btn btn-success col-xs-3 pull-right" (click)="addOrUpdateDashboard()">{{buttonValue}}</button>
                        <button type="button" class="btn btn-basic col-xs-3 pull-right" style="margin-bottom: 15px;" (click)="modalRef.hide()">Cancel</button>
                    </div>
                    <div *ngIf="titleForDashboardModal == 'New Dashboard'" style="margin-top: 15px;">
                        <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
                        <button type="button" class="btn btn-success col-xs-3 pull-right" (click)="addOrUpdateDashboard()">{{buttonValue}}</button>
                        <button type="button" class="btn btn-basic col-xs-3 pull-right" style="margin-bottom: 15px;" (click)="modalRef.hide()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #loading>
    <div class="col-xs-4 col-lg-3">
        <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 20px;"></i>
        <span>Loading...</span>
    </div>
</ng-template>


<ng-template #triggerHistoryTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="trigger-history-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Recent Event Actions:&nbsp;&nbsp;{{currentEventName}}</h5>
            <button
                (click)="modalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>         
        </div>
        <div>
            <div>
                <p-table #eventHistoryTable [exportFunction]="exportCsv" *ngIf="selectedEventLogHistory.length > 0"
                    [columns]="triggerHistoryCols" [value]="selectedEventLogHistory" sortField="LastTriggeredDate" sortOrder="-1" exportFilename={{exportName}} [scrollable]="true" scrollHeight="50vh">

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.header=='Date' || col.header=='Action Results'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr>
                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                {{rowData.createdDate | date : 'medium'}}
                            </td>
                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                <table style="width: 100%;">
                                    <tr *ngFor = "let conditionResult of rowData.conditionResults">
                                        <td width="80%">
                                            {{conditionResult.text}}
                                        </td>
                                        <td width="20%">
                                        <div *ngIf="conditionResult.parentType=='Sensor Based'">
                                            {{conditionResult.value}}
                                        </div>
                                        <div *ngIf="conditionResult.parentType!='Sensor Based'">
                                            <div [ngStyle]="{'color': getEventLogResultColor(conditionResult.value)}">
                                                {{conditionResult.value}}
                                            </div>
                                        </div>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                <div *ngFor="let actionResult of rowData.actionResults">
                                  <div [ngStyle]="{'background-color': getEventLogColor(actionResult.value)}">
                                    {{actionResult.text}}
                                  </div>
                                </div>
                            </td>
                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                {{rowData.ElapsedTime}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #dashboardImageFavorite>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" [kigResizableModal]="1200">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Image Favorite:&nbsp;&nbsp;{{enlargedImageFavorite?.name}}</h5>
            <button
                (click)="modalRef.hide()"
                class="ms-auto fas fa-times" type="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
            </button>
        </div>

        <div class="modal-body" style="padding: 10px;">
            <kig-image-favorite *ngIf="enlargedImageFavorite != null"
                                [imageFavorite]="enlargedImageFavorite"
                                size="Large"
                                [fillWidth]="true"
                                [minimal]="true"
                                [labelsEditable]="false"
                                [username]="username">
            </kig-image-favorite>
        </div>
    </div>
</ng-template>


<ng-template #dashboardMapFavorite>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" [kigResizableModal]="1140" [resizableHeight]="760">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Map Favorite:&nbsp;&nbsp;{{enlargedMapFavorite?.name}}</h5>
            <button
                (click)="modalRef.hide()"
                class="ms-auto fas fa-times" type="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
            </button>
        </div>

        <div class="modal-body" style="padding: 10px;">
            <kig-map-favorite-tile *ngIf="enlargedMapFavorite != null"
                                   [mapFavorite]="enlargedMapFavorite"
                                   [height]="'100%'">
            </kig-map-favorite-tile>
        </div>
    </div>
</ng-template>


<ng-template #dashboardChart>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="dashboardChart" [kigResizableModal]="1210" [resizableHeight]="880">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Chart:&nbsp;&nbsp;{{currentEventName}}</h5>
            <button
                (click)="modalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>

        <div class="modal-body" style="padding-left: 10px; background-color: white;">
            <div id="chartContainer3" style="background-color: white; height: 100%;">
                <chart-readings-echart-modal
                    [sensors]="currentSensors"
                    [sensorReadings]="currentSensorReadings"
                    [sensorReadingTypes]="currentSensorReadingTypes"
                    [includeCalValues]="currentIncludeCalValues"
                    [includeOrigValues]="currentIncludeOrigValues"
                    [savedChartDetails]="currentSavedChartDetails"
                    [chartFavoriteId]="currentChartFavoriteId"
                    [manualScaling]="currentManualScaling"
                    [manualScaleYMin]="currentScaleYMin"
                    [manualScaleYMax]="currentScaleYMax"
                    [showYAxisSlider]="true"
                    [fillHeight]="true">
                </chart-readings-echart-modal>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #conditionValueHistoryTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="condition-values-modal shadow-lg bg-white rounded">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Recent Values:&nbsp;&nbsp;{{currentEventName}}</h5>
            <button
                (click)="modalRef.hide()"
                class="ms-auto fas fa-times"pe="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>

        <div style="padding: 10px; width: 100%;">
            <table style="width: 100%;">
                <tr *ngFor = "let conditionValue of recentConditionValues">
                    <td width="42%">
                        {{conditionValue.createdDate | date : 'medium'}}
                    </td>
                    <td width="30%" class="text-center">
                        {{conditionValue.value}}
                    </td>
                    <td width="28%" class="text-center">
                        <div [ngStyle]="{'background-color': getEventLogColor(conditionValue.errorCode)}">
                            {{conditionValue.errorName}}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>


